export default "__VITE_ASSET__lnZkbMrb__"